import React, {Component} from "react";
import ProsRbTagMenu from "./ProsRbTagMenu";
import * as prosConnect from "./ProsConnect";
import {ATTR_OBJ_ID, ATTR_OBJ_TYPE, STR_NO_VALUE} from "./ProsConnect";
//import DropdownMenu from "../components/DropdownMenu";
import BasicButton from "../components/BasicButton";
import BasicModal, {BasicModalDismiss} from "../components/BasicModal";


export default class ProsRbTag extends Component {
    constructor(props) {
        super(props)
        this.state = {
            selectedIndex: null
        }
    }
    modalContent = null
    showMenu(title) {
        if(this.props.disabled){
            return
        }
        BasicModal(title, this.modalContent, {
            action: ()=> {
                this.saveObs(this.state.selectedIndex)
            }
        })
    }

    async saveObs(selectedIndex) {
        let attrChanges = {
            [ATTR_OBJ_ID]: this.props.obs[ATTR_OBJ_ID],
            [ATTR_OBJ_TYPE]: this.props.obs[ATTR_OBJ_TYPE],
            [this.props.tag]: selectedIndex.toString()
        }
        await prosConnect.getActiveProject().awaitUpdateMultipleItemsAttributes([attrChanges])
        BasicModalDismiss()
    }

    getBgColorByTagValue(project, tagValue, tagIndex, isMandatoryAndMissing) {
        if(isMandatoryAndMissing) return '#fab192'
        let chosenTag = project.tagIndexToId(tagIndex);
        let hexNumber = project.getBgHexNumberByTagValue(chosenTag, tagValue);
        return hexNumber ? '#' + hexNumber : null
    }

    permissionToEditTag(tagIndex, tagSelectedOption) {
        return this.props.project.mayEditRgTag(tagIndex, tagSelectedOption)
    }

    render() {
        const {project, obs, tagIndex, tag} = this.props
        let tagVal = -1
        let title = project.getRbTagTitles()[tagIndex]    // example 'Tila'
        let labels = project.getRbTagLabels(tagIndex)     // example 'Kirjattu', 'Korjattu', Tarkastettu';
        if (!title || !labels || labels.length < 2) {
            return null
        }
        let isMandatory = project.isRbTagMandatory(tag);
        if (obs.hasOwnProperty(tag) && obs[tag] !== STR_NO_VALUE) {
            tagVal = parseInt(obs[tag]);
            if (project.getRbTagTitles().length < tagIndex) {
                // console.log('RB TAG tag', tag, 'tagVal', tagVal, 'tagIndex', tagIndex, ' tagIndex is out of range');
                return null
            }
        }
        if (labels.length < tagVal) {
            // console.log('RB TAG tag', tag, 'tagVal', tagVal, 'tagIndex', tagIndex, ' tagVal is out of range', labels);
            tagVal = -1
        }
        if (!isMandatory && tagVal < 0) {
            return null
        }
        let tagOptionIndeces = project.getMayEditRbTagIndeces(obs, tagIndex)
        let btnType = this.permissionToEditTag(tagIndex, tagVal) || tagOptionIndeces.length > 0 ? null : "locked"
        let isMissing = tagVal < 0
        const isMandatoryAndMissing = isMandatory && isMissing
        this.modalContent = tagOptionIndeces.length ?
            <ProsRbTagMenu
                tagOptionIndeces={tagOptionIndeces}
                selectedIndex={tagVal}
                isMenuShown={true}
                onSelect={(ind)=> this.setState({selectedIndex: ind})}
                tagInd={tagIndex}
                project={project}
                isMandatoryAndMissing={isMandatoryAndMissing}
            /> : null
        let tagText = isMissing ? '-' : project.getRbTagLabels(tagIndex)[tagVal]
        const bgColor = this.getBgColorByTagValue(project, tagVal, tagIndex, isMandatoryAndMissing)
        //Todo Sampo: styling & color & etc
        // if(labels.length < 5) {
        //     let mvTag = this.props.project.getMvTagSettings(tagIndex)
        //     let menuValues = tagOptionIndeces.map(i => {
        //         let option = mvTag.options.find(option => option.optionIndex === i)
        //         if (!option || !option.inUse) {
        //             return null
        //         }
        //         return {
        //             text: option.label,
        //             value: option.optionIndex
        //         }
        //     })
        //     return <DropdownMenu
        //         values={menuValues}
        //         currentValue={tagVal}
        //         text={title}
        //         onSelect={(ind)=>{
        //             this.setState({selectedIndex: ind})
        //             this.saveObs(ind)
        //         }}
        //     />
        // }

        return <BasicButton
                label={<><div className={"text-xs"}>{title}</div><strong>{tagText}</strong></>}
                required={isMissing || null}
                disabled={this.props.disabled}
                action={()=> this.showMenu(title)}
                className={"btn-text-stacked" + (!isMandatoryAndMissing ? " btn-has-color-tag" : "")}
                btnType={btnType}
            >
                {bgColor && !isMandatoryAndMissing ? <i className={"btn-tag btn-tag-color"} style={{backgroundColor: bgColor}}/> : null}
        </BasicButton>
    }
}